module.exports = __webpack_public_path__ + "static/softPads-1ba46eb1007f67e3b7284e4883f816e6.jpg";